import { traitSaleContract } from "config";
import useHoneyAllowance from "hooks/useHoneyAllowance";

const useHoneyTraitsSaleAllowance = (address?: string) =>
  useHoneyAllowance(traitSaleContract.address, address);

export default useHoneyTraitsSaleAllowance;
